import { Component, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { DeliveryTimeUnit } from '@lib/util';
import { IDemandAddProductDeliveryForm } from '../../demand-add-product.component';
import dayjs from 'dayjs';

@Component({
    selector: 'demand-product-delivery-input',
    templateUrl: './demand-product-delivery-input.component.html',
    styleUrls: ['./demand-product-delivery-input.component.scss'],
    standalone: false
})
export class DemandProductDeliveryInputComponent {
    @Input() public formGroup!: FormGroup<IDemandAddProductDeliveryForm>;

    public DeliveryTimeUnit = DeliveryTimeUnit;

    public today = dayjs();
    public get isPreferredDeliveryDateRequired(): boolean {
        return this.formGroup.controls['preferredDeliveryDate'].hasValidator(Validators.required);
    }
}
